<div class="ds-modal solicitud">
    <app-spinner
        [show]="!flagLoaded"
        [text]="'Cargando detalles de la solicitud...'"
        [type]="'fullscreen'"
        [color]="'#B1476A'"
        [trackColor]="'#4CA7C8'"
        [blurBackground]="true"
    ></app-spinner>

    <app-spinner
        [show]="flagSpinner"
        [text]="'Procesando, por favor espere...'"
        [type]="'fullscreen'"
        [color]="'#B1476A'"
        [trackColor]="'#4CA7C8'"
        [blurBackground]="true"
    ></app-spinner>

    <div class="ds-accent"></div>

    <!-- ============ Cabecera ============ -->
    <div class="ds-modal__head">
        <span class="ds-modal__head-icon material-icons">assignment</span>
        <div>
            <h2>{{ solicitud?.actividad?.nombre || 'Detalle solicitud' }}</h2>
            <p *ngIf="solicitud?._nro">Solicitud Nº {{ solicitud._nro }}</p>
        </div>
        <span class="ds-modal__spacer"></span>
        <span class="ds-chip" [ngClass]="chipEstado" *ngIf="flagLoaded">
            {{ solicitud?.lastState?.numberState | estadosPipe }}
        </span>
        <button type="button" class="ds-icon-btn" (click)="closeModal()" aria-label="Cerrar">
            <span class="material-icons">close</span>
        </button>
    </div>

    <!-- ============ Cuerpo ============ -->
    <div class="ds-modal__body" *ngIf="flagLoaded">
        <div class="solicitud__grid">
            <!-- ---------- Columna izquierda ---------- -->
            <div class="solicitud__col">
                <app-ofertas-estado-detalle
                    seccion="contacto"
                    [solicitud]="solicitud"
                    [usuario]="usuario"
                    [beneficiario]="beneficiario"
                    [nombrePais]="nombrePais"
                    [estadoDocumentacion]="estadoDocumentacion"
                    [cobertura]="coberturaSolicitud"
                    [esSedeInscripcion]="false"
                ></app-ofertas-estado-detalle>

                <div class="ds-card">
                    <div class="ds-section__head">
                        <span class="material-icons">photo_library</span>
                        Documentación — Fotos
                    </div>
                    <div class="ds-section__body">
                        <ng-container *ngIf="imgs.length > 0; else noFotos">
                            <app-ofertas-gallery [imagenes]="imgs" [id_usuario]="usuario._id"></app-ofertas-gallery>

                            <h4 class="solicitud__sub">Listado de imágenes</h4>
                            <div class="ds-list">
                                <div class="ds-list__item" *ngFor="let img of imgs">
                                    <span class="ds-list__item-icon material-icons">image</span>
                                    <span class="ds-list__item-label">{{ nombresImagenes[img] || img }}</span>
                                    <span class="ds-list__item-actions">
                                        <button type="button" class="ds-pill ds-pill--outline ds-pill--sm"
                                            (click)="verImagen(img)">
                                            <span class="material-icons">visibility</span>
                                            Ver
                                        </button>
                                        <button type="button" class="ds-pill ds-pill--primary ds-pill--sm"
                                            (click)="descargarImagenPDF(img)">
                                            <span class="material-icons">picture_as_pdf</span>
                                            PDF
                                        </button>
                                    </span>
                                </div>
                            </div>
                        </ng-container>

                        <ng-template #noFotos>
                            <div class="ds-alert ds-alert--info">
                                <span class="material-icons">photo_library</span>
                                <div>No se encontraron fotos.</div>
                            </div>
                        </ng-template>
                    </div>
                </div>

                <div class="ds-card">
                    <div class="ds-section__head">
                        <span class="material-icons">folder</span>
                        Documentación — Archivos
                    </div>
                    <div class="ds-section__body">
                        <ng-container *ngIf="filesAfiliado.length > 0; else noArchivos">
                            <app-ofertas-files [files]="filesAfiliado" [usuario]="usuario"></app-ofertas-files>
                        </ng-container>

                        <ng-template #noArchivos>
                            <div class="ds-alert ds-alert--info">
                                <span class="material-icons">folder_off</span>
                                <div>No se encontraron archivos.</div>
                            </div>
                        </ng-template>
                    </div>
                </div>

                <!-- Documentación enviada por el administrador al aprobar -->
                <div class="ds-card" *ngIf="filesAdmin.length > 0">
                    <div class="ds-section__head">
                        <span class="material-icons">verified_user</span>
                        Documentación enviada por Administración
                    </div>
                    <div class="ds-section__body">
                        <app-ofertas-files [files]="filesAdmin" [usuario]="usuario"></app-ofertas-files>
                    </div>
                </div>

                <app-ofertas-estado-detalle
                    seccion="detalles"
                    [solicitud]="solicitud"
                    [usuario]="usuario"
                    [beneficiario]="beneficiario"
                    [nombrePais]="nombrePais"
                    [estadoDocumentacion]="estadoDocumentacion"
                    [cobertura]="coberturaSolicitud"
                    [esSedeInscripcion]="false"
                ></app-ofertas-estado-detalle>

                <div class="ds-card">
                    <div class="ds-section__head">
                        <span class="material-icons">history</span>
                        Historial de estados
                    </div>
                    <div class="ds-section__body">
                        <div class="ds-timeline" *ngIf="historialConUsuario.length; else noHistorial">
                            <div class="ds-timeline__item"
                                *ngFor="let hs of historialConUsuario; let first = first"
                                [class.ds-timeline__item--current]="first">
                                <span class="ds-timeline__dot"></span>
                                <span class="ds-timeline__date">
                                    {{ hs.updatedAt | date: 'dd/MM/yyyy HH:mm' }}
                                </span>
                                <span class="ds-timeline__title">
                                    {{ hs.state || 'N/A' }} — {{ hs.userName }}
                                </span>
                                <span class="ds-timeline__text">
                                    {{ hs.observaciones || hs.observacionRecupero || 'No hay observaciones.' }}
                                    <span class="solicitud__lock" *ngIf="hs.observacionRecupero"
                                        title="Observación interna de Recupero: el afiliado no la ve ni la recibe por mail">
                                        <span class="material-icons">lock</span> Recupero
                                    </span>
                                </span>
                            </div>
                        </div>

                        <ng-template #noHistorial>
                            <div class="ds-alert ds-alert--info">
                                <span class="material-icons">history</span>
                                <div>No hay historial de estados disponible.</div>
                            </div>
                        </ng-template>
                    </div>
                </div>
            </div>

            <!-- ---------- Columna derecha ---------- -->
            <div class="solicitud__col">
                <!-- Estado de la solicitud -->
                <div class="ds-card">
                    <div class="ds-section__head">
                        <span class="material-icons">timeline</span>
                        Estado de la solicitud
                    </div>
                    <div class="ds-section__body">
                        <app-stepper
                            [stepperSet]="estadoParaStepper"
                            [vertical]="false"
                            [mostrarRecupero]="esTramiteRecupero"
                        ></app-stepper>

                        <ng-container
                            *ngIf="flagEnRevision || flagEnAuditoria || flagEnRecupero || flagLabelAprobado || flagLabelRechazado || flagLabelEnEspera || flagLabelPresentado; else incompleteAlert">
                            <div class="ds-alert ds-alert--warning" *ngIf="flagLabelEnEspera">
                                <span class="material-icons">hourglass_empty</span>
                                <div>
                                    <strong>Solicitud en espera.</strong>
                                    Motivo: {{ solicitud.lastState?.observaciones || 'Sin especificar' }}
                                </div>
                            </div>

                            <div class="ds-alert ds-alert--info" *ngIf="flagEnRevision">
                                <span class="material-icons">rate_review</span>
                                <div>Solicitud en revisión por parte de la sede.</div>
                            </div>

                            <div class="ds-alert ds-alert--warning" *ngIf="flagEnRecupero">
                                <span class="material-icons">autorenew</span>
                                <div>Solicitud en Recupero.</div>
                            </div>

                            <div class="ds-alert ds-alert--info" *ngIf="flagEnAuditoria">
                                <span class="material-icons">fact_check</span>
                                <div>Solicitud en Auditoría médica.</div>
                            </div>

                            <div class="ds-alert ds-alert--success" *ngIf="flagLabelAprobado">
                                <span class="material-icons">check_circle</span>
                                <div>Solicitud aprobada.</div>
                            </div>

                            <div class="ds-alert ds-alert--danger" *ngIf="flagLabelRechazado">
                                <span class="material-icons">block</span>
                                <div>
                                    <strong>Solicitud anulada.</strong>
                                    Motivo: {{ solicitud.lastState?.observaciones || 'Sin especificar' }}
                                </div>
                            </div>

                            <div class="ds-alert ds-alert--info" *ngIf="flagLabelPresentado">
                                <span class="material-icons">description</span>
                                <div>Solicitud presentada.</div>
                            </div>
                        </ng-container>

                        <!-- Observaciones de los pasos anteriores: aviso dentro de
                             la tarjeta de estado, en otro color que el del estado
                             (no un bloque aparte). -->
                        <div class="ds-alert ds-alert--info" *ngFor="let obs of observacionesPasos">
                            <span class="material-icons">comment</span>
                            <div class="obs-paso">
                                <strong class="obs-paso__titulo">Observación del estado {{ obs.estado }}:</strong>
                                <span class="obs-paso__texto">{{ obs.texto }}</span>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Revisión -->
                <div class="ds-card" *ngIf="activarEnRevision">
                    <div class="ds-section__head">
                        <span class="material-icons">rate_review</span>
                        Revisión
                    </div>
                    <div class="ds-section__body">
                        <p class="solicitud__texto">
                            Si las autorizaciones y/o documentación presentadas por el afiliado están
                            incompletas o falta documentación necesaria, envíe una observación para que el
                            afiliado pueda completar su solicitud.
                        </p>

                        <label class="ds-switch">
                            <input type="checkbox" [(ngModel)]="isCheckedEnRevision">
                            <span class="ds-switch__track"><span class="ds-switch__thumb"></span></span>
                            <span class="ds-switch__label">Agregar una observación al afiliado</span>
                        </label>

                        <div class="ds-textarea" *ngIf="isCheckedEnRevision">
                            <label class="ds-textarea__label" for="motivoRevision">Observaciones</label>
                            <textarea id="motivoRevision" class="ds-textarea__control" [(ngModel)]="motivoRevision"
                                placeholder="Incluya las observaciones pertinentes para informar al afiliado"></textarea>
                        </div>

                        <div class="solicitud__actions">
                            <button type="button" class="ds-pill ds-pill--primary"
                                (click)="actualizarEstadoSolicitud(solicitud._id, iAppOfertas.estado_2.number, false, iAppOfertas.estado_2.name, true, isCheckedEnRevision ? motivoRevision : undefined)">
                                {{ isCheckedEnRevision ? 'Poner en revisión y agregar observación' : 'Poner en revisión' }}
                            </button>
                        </div>
                    </div>
                </div>

                <!-- Observación Recupero -->
                <div class="ds-card" *ngIf="activarEnRecupero">
                    <div class="ds-section__head">
                        <span class="material-icons">autorenew</span>
                        Observación Recupero
                    </div>
                    <div class="ds-section__body">
                        <p class="solicitud__texto">
                            Asigne una observación y envíe la solicitud a Recupero para su gestión.
                        </p>

                        <div class="ds-textarea">
                            <label class="ds-textarea__label" for="observacionRecupero">Observación</label>
                            <textarea id="observacionRecupero" class="ds-textarea__control" [(ngModel)]="observacionRecupero"
                                placeholder="Incluya la observación para Recupero"></textarea>
                        </div>

                        <div class="solicitud__actions">
                            <button type="button" class="ds-pill ds-pill--primary" (click)="mandarARecupero()">
                                Mandar a Recupero
                            </button>
                        </div>
                    </div>
                </div>

                <!-- Derivación a Auditoría -->
                <div class="ds-card" *ngIf="activarEnAuditoria">
                    <div class="ds-section__head">
                        <span class="material-icons">fact_check</span>
                        Derivación a Auditoría Médica
                    </div>
                    <div class="ds-section__body">
                        <p class="solicitud__texto">
                            Si la autorización presenta dificultades y no se puede aprobar, es recomendable
                            derivarla a auditoría para que realice un análisis exhaustivo.
                        </p>

                        <div class="ds-alert ds-alert--warning">
                            <span class="material-icons">priority_high</span>
                            <div>
                                <strong>Importante:</strong> al derivar a auditoría médica se enviarán los
                                documentos adjuntos y cambiará el estado de la solicitud a
                                mail_signomedico@osoetsylra.org
                            </div>
                        </div>

                        <div class="ds-textarea">
                            <label class="ds-textarea__label" for="observacionEmailAuditoriaMedica">
                                Observación email (opcional)
                            </label>
                            <textarea id="observacionEmailAuditoriaMedica" class="ds-textarea__control"
                                [(ngModel)]="observacionEmailAuditoriaMedica"
                                [disabled]="!activarEnAuditoria || !botonAuditoriaHabilitado || flagEnAuditoria"
                                placeholder="Ingrese su observación aquí…"></textarea>
                            <span class="ds-textarea__hint">
                                Esta observación será enviada al afiliado.
                            </span>
                        </div>

                        <div class="solicitud__actions">
                            <button type="button" class="ds-pill ds-pill--primary"
                                *ngIf="activarEnAuditoria && botonAuditoriaHabilitado && !flagEnAuditoria"
                                [disabled]="flagSpinner" (click)="derivarYAudiarSolicitud(solicitud._id)">
                                Derivar a Auditoría Médica
                            </button>
                            <button type="button" class="ds-pill ds-pill--primary" disabled
                                *ngIf="!activarEnAuditoria || !botonAuditoriaHabilitado || flagEnAuditoria">
                                Derivar a Auditoría Médica
                            </button>
                        </div>

                        <div class="ds-alert ds-alert--info" *ngIf="solicitud?.adjuntos?.length <= 0 && !flagSpinner">
                            <span class="material-icons">info</span>
                            <div><strong>Importante:</strong> no hay documentos adjuntos para enviar.</div>
                        </div>

                        <!-- Observación interna -->
                        <div class="ds-card solicitud__inner">
                            <div class="ds-section__head">
                                <span class="material-icons">lock</span>
                                Observación Interna (solo administradores)
                            </div>
                            <div class="ds-section__body">
                                <div class="ds-alert ds-alert--info">
                                    <span class="material-icons">info</span>
                                    <div>
                                        Visible solo para administradores. No se comparte con el afiliado.
                                    </div>
                                </div>

                                <div class="ds-textarea">
                                    <label class="ds-textarea__label" for="observacionInterna">
                                        Observación interna (no visible para el afiliado)
                                    </label>
                                    <textarea id="observacionInterna" class="ds-textarea__control"
                                        [(ngModel)]="observacionInterna"
                                        (input)="habilitarBotonObservacionesInternas(observacionInterna)"
                                        placeholder="Escriba una observación interna sobre esta solicitud..."></textarea>
                                </div>

                                <div class="solicitud__actions">
                                    <button type="button" class="ds-pill ds-pill--primary"
                                        [disabled]="!habilitarGuardarObservacionInterna"
                                        (click)="guardarObservacionInterna()">
                                        Guardar Observación Interna
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Aprobar -->
                <div class="ds-card" *ngIf="activarAprobar">
                    <div class="ds-section__head">
                        <span class="material-icons">verified</span>
                        Aprobar
                    </div>
                    <div class="ds-section__body">
                        <p class="solicitud__texto">
                            Si todo está correcto, aprueba la solicitud y se notificará al afiliado.
                        </p>

                        <label class="ds-switch">
                            <input type="checkbox" [(ngModel)]="isCheckedAprobar">
                            <span class="ds-switch__track"><span class="ds-switch__thumb"></span></span>
                            <span class="ds-switch__label">Activar aprobación</span>
                        </label>

                        <ng-container *ngIf="isCheckedAprobar">
                            <div class="ds-card solicitud__inner">
                                <div class="ds-section__head">
                                    <span class="material-icons">upload_file</span>
                                    Subir archivos para aprobación
                                </div>
                                <div class="ds-section__body">
                                    <p class="solicitud__texto" *ngIf="selectedFiles.length">
                                        Ha seleccionado {{ selectedFiles.length }}
                                        {{ selectedFiles.length === 1 ? 'archivo' : 'archivos' }}. Se
                                        fusionarán en un único PDF que recibirá el afiliado.
                                    </p>

                                    <div class="ds-list" *ngIf="selectedFiles.length">
                                        <div class="ds-list__item" *ngFor="let fg of selectedFiles; let i = index">
                                            <span class="ds-list__item-icon material-icons">picture_as_pdf</span>
                                            <span class="ds-list__item-label">
                                                {{ fg.fileName || 'No hay archivo...' }}
                                            </span>
                                            <span class="ds-list__item-actions">
                                                <label class="ds-pill ds-pill--outline ds-pill--sm">
                                                    <span class="material-icons">upload_file</span>
                                                    Seleccionar PDF
                                                    <input type="file" accept="application/pdf" hidden
                                                        (change)="onFileSelected($event, i)" />
                                                </label>
                                                <button type="button" class="ds-icon-btn" (click)="removeFile(i)"
                                                    aria-label="Quitar archivo">
                                                    <span class="material-icons">delete</span>
                                                </button>
                                            </span>
                                        </div>
                                    </div>

                                    <div class="solicitud__actions solicitud__actions--start">
                                        <button type="button" class="ds-pill ds-pill--outline" (click)="addFileRow()">
                                            <span class="material-icons">add</span>
                                            Agregar orden
                                        </button>
                                    </div>
                                </div>
                                <div class="ds-modal__actions">
                                    <button type="button" class="ds-pill ds-pill--primary"
                                        [disabled]="selectedFiles.length === 0 || flagDisableButtonApprove"
                                        (click)="aprobarSolicitud()">
                                        <span class="material-icons">check_circle</span>
                                        Aprobar trámite
                                    </button>
                                </div>
                            </div>
                        </ng-container>
                    </div>
                </div>

                <!-- Poner en Espera -->
                <div class="ds-card" *ngIf="activarEnEspera">
                    <div class="ds-section__head">
                        <span class="material-icons">hourglass_empty</span>
                        Poner en Espera
                    </div>
                    <div class="ds-section__body">
                        <div class="ds-alert ds-alert--warning">
                            <span class="material-icons">priority_high</span>
                            <div>
                                Al poner en espera la solicitud, se notificará al afiliado y quedará en
                                estado de espera hasta nueva revisión.
                            </div>
                        </div>

                        <label class="ds-switch">
                            <input type="checkbox" [(ngModel)]="isCheckedEnEspera">
                            <span class="ds-switch__track"><span class="ds-switch__thumb"></span></span>
                            <span class="ds-switch__label">Activar para poner en espera</span>
                        </label>

                        <ng-container *ngIf="isCheckedEnEspera">
                            <div class="ds-textarea">
                                <label class="ds-textarea__label" for="motivoEspera">Motivo de la espera</label>
                                <textarea id="motivoEspera" class="ds-textarea__control" [(ngModel)]="motivoEnEspera"
                                    (input)="habilitarBotonObservaciones(motivoEnEspera)"
                                    placeholder="Describa el motivo por el cual se pone en espera..."></textarea>
                            </div>

                            <div class="solicitud__actions">
                                <button type="button" class="ds-pill ds-pill--primary"
                                    [disabled]="!habilitarEnviarObservacion"
                                    (click)="actualizarEstadoSolicitud(solicitud._id, iAppOfertas.estado_6.number, false, iAppOfertas.estado_6.name, true, motivoEnEspera)">
                                    Poner en Espera
                                </button>
                            </div>
                        </ng-container>
                    </div>
                </div>

                <!-- Anular -->
                <div class="ds-card" *ngIf="activarRechazar">
                    <div class="ds-section__head">
                        <span class="material-icons">block</span>
                        Anular
                    </div>
                    <div class="ds-section__body">
                        <div class="ds-alert ds-alert--danger">
                            <span class="material-icons">warning</span>
                            <div>
                                Al <strong>ANULAR</strong> una solicitud, el afiliado tendrá que reenviar la
                                autorización y su documentación nuevamente.
                            </div>
                        </div>

                        <label class="ds-switch">
                            <input type="checkbox" [(ngModel)]="isCheckedRechazar">
                            <span class="ds-switch__track"><span class="ds-switch__thumb"></span></span>
                            <span class="ds-switch__label">Active la opción para anular</span>
                        </label>

                        <ng-container *ngIf="isCheckedRechazar">
                            <div class="ds-textarea">
                                <label class="ds-textarea__label" for="motivoRechazo">Motivo de anulación</label>
                                <textarea id="motivoRechazo" class="ds-textarea__control" [(ngModel)]="motivoRechazo"
                                    (input)="habilitarBotonObservaciones(motivoRechazo)"
                                    placeholder="Escriba el motivo por el cual se anula la solicitud..."></textarea>
                            </div>

                            <div class="solicitud__actions">
                                <button type="button" class="ds-pill ds-pill--primary"
                                    [disabled]="!habilitarEnviarObservacion"
                                    (click)="actualizarEstadoSolicitud(solicitud._id, iAppOfertas.estado_5.number, false, iAppOfertas.estado_5.name, true, motivoRechazo)">
                                    Anular
                                </button>
                            </div>
                        </ng-container>
                    </div>
                </div>

                <!-- Deshacer anulación -->
                <div class="ds-card" *ngIf="flagLabelRechazado">
                    <div class="ds-section__head">
                        <span class="material-icons">undo</span>
                        Deshacer Anulación
                    </div>
                    <div class="ds-section__body">
                        <p class="solicitud__texto">La solicitud pasará a revisión.</p>
                        <div class="solicitud__actions">
                            <button type="button" class="ds-pill ds-pill--outline"
                                [disabled]="!activarDeshacerAnulacion" (click)="deshacerAnulacion()">
                                Deshacer Anulación
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <ng-template #incompleteAlert>
        <div class="ds-alert ds-alert--danger">
            <span class="material-icons">warning</span>
            <div>El afiliado no completó la solicitud y la dejó parcial sin la documentación mínima.</div>
        </div>
    </ng-template>

    <div class="ds-modal__actions" *ngIf="flagLoaded">
        <button type="button" class="ds-pill ds-pill--ghost" (click)="closeModal()">Cerrar</button>
    </div>
</div>
